import React, { useEffect } from "react";
import { observer } from "mobx-react";
import { Card, Table, Input, Layout, Form, Select, Col } from "antd";
import dayjs from "dayjs";
import customParseFormat from "dayjs/plugin/customParseFormat";
import { useHistory, useLocation } from "react-router-dom";
import { userUpdateChooseCommunityStore } from "../../store/user/UserUpdateChooseCommunityStore";
import { SelectCommunityDlg } from "../../components/community/SelectCommunityDlg";
import { userActivitiesStore } from "../../store/activity/UserActivitiesStore";
import { fmtDateTime2 } from "../../common/Utils";
import { UserLink } from "../../components/UserLink/UserLink";
import { SortOrder } from "antd/lib/table/interface";
import { RegionFilterBar } from "../../components/filter/RegionFilterBar";
import { UserActivityDlg } from "./UserActivityDlg";
import { userActivityStore } from "../../store/activity/UserActivityStore";

dayjs.extend(customParseFormat);

export const UserActivities = observer(() => {
  const store = userActivitiesStore;
  const setCommunityStore = userUpdateChooseCommunityStore;

  const location = useLocation();

  const history = useHistory();

  useEffect(() => {
    store.onLocation(location);
  }, []);

  useEffect(() => {
    store.onLocation(location);
  }, [location.search]);

  // const onStatus = (status) => {
  //   const query = new URLSearchParams({ status });
  //   history.push({
  //     search: query.toString(),
  //   });
  // };

  // const setCommunity = (id) => {
  //   setCommunityStore.show(id);
  // };

  // const edit = (id) => {
  //   userEditStore.edit(id);
  // };

  const onPage = (page, pageSize) => {
    store.onPage(history, page, pageSize);
  };

  const onChange = (pagination, filters, sorter) => {
    store.sortedInfo = sorter;
    store.refresh();
  };

  const onDetail = (it: any) => {
    userActivityStore.showDetail(it);
  };
  const columns = [
    { title: "", key: "i", render: (t, r, i) => i + 1 },
    {
      title: "Date Posted",
      key: "createDate",
      dataIndex: "createDate",
      render: (val) => fmtDateTime2(val),
      sorter: true,
      sortOrder: store.sortedInfo.columnKey === "createDate" ? (store.sortedInfo.order as SortOrder) : undefined,
    },
    {
      title: "Category",
      key: "category.keyword",
      dataIndex: "category",
      sorter: true,
      sortOrder: store.sortedInfo.columnKey === "category.keyword" ? (store.sortedInfo.order as SortOrder) : undefined,
    },
    {
      title: "Sender / Donor / En. Participant",
      key: "sender.keyword",
      dataIndex: "sender",
      sorter: true,
      sortOrder: store.sortedInfo.columnKey === "sender.keyword" ? (store.sortedInfo.order as SortOrder) : undefined,
      render: (_, r) => <UserLink userId={r.senderId} name={r.sender} />,
    },
    {
      title: "Title",
      key: "title.keyword",
      dataIndex: "title",
      sorter: true,
      sortOrder: store.sortedInfo.columnKey === "title.keyword" ? (store.sortedInfo.order as SortOrder) : undefined,
      render: (txt, r) => (
        <span className="link" onClick={() => onDetail(r)}>
          {txt || "-"}
        </span>
      ),
    },
    {
      title: "Status",
      key: "status.keyword",
      dataIndex: "status",
      sorter: true,
      sortOrder: store.sortedInfo.columnKey === "status.keyword" ? (store.sortedInfo.order as SortOrder) : undefined,
    },
    // {
    //   title: "Amount",
    //   key: "amount",
    //   dataIndex: "amount",
    //   render: (v) => (v ? currency(v / 100.0, { precision: 2 }).format() : "-"),
    // },
    // {
    //   title: "",
    //   key: "actions",
    //   render: (t, r) => (Store.isDivision ? null : <div>{<EditOutlined onClick={() => edit(r.id)} />}</div>),
    // },
  ];

  return (
    <Layout.Content className="padding24">
      <RegionFilterBar store={store}>
        <Col span={8}>
          <Form.Item label="Category">
            <Select
              style={{ width: "100%" }}
              value={store.filter.category}
              onChange={(e) => (store.filter.category = e)}
            >
              {store.categories.map((x: any) => (
                <Select.Option value={x.id} key={x.id}>
                  {x.name}
                </Select.Option>
              ))}
            </Select>
          </Form.Item>
        </Col>
        <Col span={8}>
          <Form.Item label="Email">
            <Input allowClear value={store.filter.email} onChange={(e) => (store.filter.email = e.target.value)} />
          </Form.Item>
        </Col>
      </RegionFilterBar>

      <Card size="small">
        <Table
          onChange={onChange}
          size="small"
          pagination={{ ...store.pagination, onChange: onPage }}
          loading={store.loading}
          rowKey="id"
          columns={columns}
          dataSource={store.data.items}
        />
        {setCommunityStore.visible && (
          <SelectCommunityDlg
            visible={setCommunityStore.visible}
            onClose={() => setCommunityStore.close()}
            onSelected={(id) => setCommunityStore.save(id)}
            communities={setCommunityStore.communities}
          />
        )}
        {userActivityStore.visible && <UserActivityDlg />}
      </Card>
    </Layout.Content>
  );
});
